"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const list_1 = require("react-toolbox/lib/list");
const sidebar_item_1 = __importDefault(require("./sidebar_item"));
const mapStateProps = (state) => {
    return {
        spots: state.spots,
    };
};
const SideBar = (props) => {
    return (React.createElement(list_1.List, { selectable: true }, props.spots && props.spots.filter((spot) => spot.visible).map((spot) => {
        return React.createElement(list_1.ListItem, { itemContent: React.createElement(sidebar_item_1.default, { spot: spot }), selectable: false });
    })));
};
exports.default = react_redux_1.connect(mapStateProps)(SideBar);
